export default "__VITE_ASSET__BZN1MwAT__"